<h3-disable-with-tooltip-helper [disable]="disabledTooltip">
  <div class="grid">
    <div class="text">{{ label }}</div>
    <div class="value">
      {{ control.value }}{{ suffix }}
      <a (click)="reset()">
        <fa-icon [icon]="faUndo"></fa-icon>
      </a>
    </div>
    <input
      type="range"
      [min]="min"
      [max]="max"
      [step]="step"
      [formControl]="control"
    />
  </div>
</h3-disable-with-tooltip-helper>
